import { isArbitraryObject } from '@logto/js';

const isLogtoSignInSessionItem = (data) => {
    if (!isArbitraryObject(data)) {
        return false;
    }
    return ['redirectUri', 'codeVerifier', 'state'].every((key) => typeof data[key] === 'string');
};
const isLogtoAccessTokenMap = (data) => {
    if (!isArbitraryObject(data)) {
        return false;
    }
    return Object.values(data).every((value) => {
        if (!isArbitraryObject(value)) {
            return false;
        }
        return (typeof value.token === 'string' &&
            typeof value.scope === 'string' &&
            typeof value.expiresAt === 'number');
    });
};

export { isLogtoAccessTokenMap, isLogtoSignInSessionItem };
